import { useState } from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import { getComponentMargin, getAnchorId } from '@/utils/builderUtils';
import Title from '@/components/Title/Title';
import RichText from '@/components/RichText/RichText';

const Container = styled.div`
  .pt-40.pt-xs-20.pb-30.mt-40.mt-xs-30 {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 14px;
    line-height: 1.428571429;
    font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
    color: #333;
    box-sizing: border-box;
    max-height: 999999px;
    padding-bottom: 30px;
    margin-top: 30px;
    padding-top: 20px;
    background: #fafafa;
  }

  .container.container-indented {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 14px;
    line-height: 1.428571429;
    font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
    color: #333;
    box-sizing: border-box;
    max-height: 999999px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    &::before,
    &::after {
      display: table;
      content: ' ';
    }
  }

  .budget-box.max-w500.center-block.text-center {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 14px;
    line-height: 1.428571429;
    font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
    color: #333;
    box-sizing: border-box;
    max-height: 999999px;
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;

    .ir251-headline.mt-0 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      text-align: center;
      box-sizing: border-box;
      margin-bottom: 10px;
      font-family: 'ZapfHumanist601BT-Roman', 'Times New Roman', Times, serif;
      font-weight: 400;
      max-height: 999999px;
      margin-top: 0 !important;
      color: #000;
      line-height: normal;
      text-transform: capitalize;
      font-size: 24px;
    }

    .ls-em25 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      font-size: 14px;
      line-height: 1.428571429;
      font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
      color: #333;
      text-align: center;
      box-sizing: border-box;
      margin: 0 0 10px;
      max-height: 999999px;
      letter-spacing: 0.025em;
    }
  }

  .characteristics-chart-tab {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 14px;
    line-height: 1.428571429;
    font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
    color: #333;
    box-sizing: border-box;
    max-height: 999999px;
    margin-top: 20px;

    .characteristics-chart-nav {
      list-style: none;
      -webkit-text-size-adjust: 100%;
      display: block;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      line-height: 1.428571429;
      color: #333;
      box-sizing: border-box;
      margin-top: 0;
      margin-bottom: 10px;
      max-height: 999999px;
      font-family: 'Avenir Medium';
      text-align: center;
      letter-spacing: 0.025em;
      text-transform: capitalize;
      padding-left: 0;
      font-size: 14px;

      li {
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        line-height: 1.428571429;
        color: #333;
        font-family: 'Avenir Medium';
        letter-spacing: 0.025em;
        text-transform: capitalize;
        font-size: 14px;
        box-sizing: border-box;
        max-height: 999999px;
        display: inline-block;
        margin: 0 5px;
      }

      .active {
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        line-height: 1.428571429;
        color: #333;
        font-family: 'Avenir Medium';
        letter-spacing: 0.025em;
        text-transform: capitalize;
        font-size: 14px;
        box-sizing: border-box;
        max-height: 999999px;
        display: inline-block;
        margin: 0 5px;
      }
    }
  }

  div {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-family: 'Avenir Medium';
    letter-spacing: 0.025em;
    text-transform: capitalize;
    font-size: 14px;
    box-sizing: border-box;
    max-height: 999999px;
    color: #999999;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    padding: 2px 0;
    cursor: pointer;

    &:hover {
      color: #183e40;
    }
  }

  .active div {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-family: 'Avenir Medium';
    letter-spacing: 0.025em;
    text-transform: capitalize;
    font-size: 14px;
    box-sizing: border-box;
    max-height: 999999px;
    text-decoration: none;
    padding: 2px 0;
    color: #183e40;
    border-bottom: 2px solid #183e40;

    &:hover {
      color: #183e40;
      border-bottom-color: #183e40;
    }
  }

  h3 {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    letter-spacing: 0.025em;
    box-sizing: border-box;
    font-weight: 400;
    text-transform: capitalize;
    max-height: 999999px;
    font-family: inherit;
    color: inherit;
    font-size: inherit;
    margin: 0;
    display: inline;
    line-height: inherit;
  }

  .characteristics-chart-details {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 14px;
    line-height: 1.428571429;
    font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
    color: #333;
    box-sizing: border-box;
    max-height: 999999px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    max-width: 320px;

    .characteristics-chart-img {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      font-size: 14px;
      line-height: 1.428571429;
      font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
      color: #333;
      text-align: center;
      box-sizing: border-box;
      max-height: 999999px;
      position: relative;

      .img-responsive.center-block {
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font-size: 14px;
        line-height: 1.428571429;
        font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
        color: #333;
        text-align: center;
        aspect-ratio: auto 320 / 206;
        width: 320px;
        box-sizing: border-box;
        border: 0;
        vertical-align: middle;
        max-height: 999999px;
        height: auto;
        max-width: 100%;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }

      button {
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font-size: 14px;
        line-height: 1.428571429;
        font-family: 'Avenir Book', Arial, Helvetica, sans-serif;
        text-align: center;
        box-sizing: border-box;
        text-decoration: none;
        color: #333;
        max-height: 999999px;
        position: absolute;
        width: 30px;
        height: 30px;
        opacity: 0;

        &.table {
          left: 21%;
          top: 8%;
        }

        &.crown {
          left: 46%;
          top: 8%;
        }

        &.girdle {
          left: 2%;
          top: 27%;
        }

        &.pavilion {
          left: 45%;
          top: 40%;
          height: 108px;
        }

        &.culet {
          left: 45%;
          top: 77%;
        }

        &.depth {
          left: 45%;
          top: 27%;
        }
      }
    }
  }
`;

interface IDiamondCutsProgramProps {
  /**
   * Optional large header
   */
  optionalLargeHeader?: {
    content: string;
    titleHTMLTag?: 'h1' | 'h2' | 'h3';
    titleSize?: 'extraLarge' | 'large' | 'medium' | 'small';
    titleWeight?: 'light' | 'normal' | 'medium' | 'bold' | 'black';
  };
  /**
   *  Rich text content of the Block
   */
  content: string;
  /**
   * Turn on to add margin to the bottom of the component
   */
  margin?: boolean;
  /**
   * Give to the component an anchor link id
   */
  anchorLinkID?: string;
}

export default function DiamondCutsProgram({
  optionalLargeHeader,
  content,
  anchorLinkID,
  margin = false,
}: IDiamondCutsProgramProps) {
  const [activeCharacteristic, setActiveCharacteristic] = useState<number>(0);
  const diamondCutCharacteristics = [
    {
      name: 'Table',
      description: 'The flat surface at the top of the diamond.',
      imageURL: '/bee2-ui/img/buying-guide/table_new.svg',
    },
    {
      name: 'Crown',
      description: 'The top portion of a diamond, from the girdle to the table.',
      imageURL: '/bee2-ui/img/buying-guide/crown_new.svg',
    },
    {
      name: 'Girdle',
      description:
        'The narrow rim around the widest part of a diamond, separating the crown from the pavilion. Also referred to as the setting edge, where a diamond is held when set in jewelry.',
      imageURL: '/bee2-ui/img/buying-guide/girdle_new.svg',
    },
    {
      name: 'Pavilion',
      description: 'The lower portion of a diamond, from girdle to the culet.',
      imageURL: '/bee2-ui/img/buying-guide/pavilion_new.svg',
    },
    {
      name: 'Culet',
      description: "The facet or point on the bottom of the diamond's pavilion.",
      imageURL: '/bee2-ui/img/buying-guide/culet_new.svg',
    },
    {
      name: 'Depth',
      description:
        'The height of a gemstone, from the culet to the table. Determined as a percentage of the overall diameter of the gem.',
      imageURL: '/bee2-ui/img/buying-guide/depth_new.svg',
    },
  ];

  return (
    <Container {...getAnchorId(anchorLinkID)} className={getComponentMargin(margin)}>
      <div className="pt-40 pt-xs-20 pb-30 mt-40 mt-xs-30" style={{ background: '#fafafa' }}>
        <div className="container container-indented">
          <div className="budget-box max-w500 center-block text-center">
            {optionalLargeHeader?.content && (
              <Title
                component={optionalLargeHeader?.titleHTMLTag || 'h2'}
                weight={optionalLargeHeader?.titleWeight}
                size={optionalLargeHeader?.titleSize}
                alignment="center"
                className="ir251-headline mt0"
              >
                {optionalLargeHeader?.content}
              </Title>
            )}
            <RichText content={content} className="ls-em25" />
          </div>
          <div className="characteristics-chart-tab mt-20">
            <ul className="characteristics-chart-nav" role="tablist">
              {diamondCutCharacteristics?.map((characteristic, index) => (
                <li
                  role="tab"
                  tabIndex={0}
                  onClick={() => {
                    window.location.hash = characteristic.name.toLowerCase();
                    setActiveCharacteristic(index);
                  }}
                  className={
                    characteristic.name === diamondCutCharacteristics[activeCharacteristic].name ? 'active' : ''
                  }
                  key={characteristic.name}
                >
                  <div>
                    <h3>{characteristic.name}</h3>
                  </div>
                </li>
              ))}
            </ul>
            <div className="characteristics-chart-details">
              <div className="characteristics-chart-img">
                {diamondCutCharacteristics?.map((characteristic, index) => (
                  <button
                    type="button"
                    key={characteristic.name}
                    title={characteristic.name}
                    onClick={() => {
                      window.location.hash = characteristic.name.toLowerCase();
                      setActiveCharacteristic(index);
                    }}
                    className={characteristic.name.toLowerCase()}
                  >
                    {characteristic.name}
                  </button>
                ))}
                <Image
                  src={diamondCutCharacteristics[activeCharacteristic].imageURL}
                  alt={diamondCutCharacteristics[activeCharacteristic].name}
                  width={320}
                  height={250}
                />
              </div>
              <h4>{diamondCutCharacteristics[activeCharacteristic].name}</h4>
              <p>{diamondCutCharacteristics[activeCharacteristic].description}</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
